<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>计划分配</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="采购订单号:" prop="orderID">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.purorderNo"></el-input>
      </el-form-item>
      <el-form-item label="采购日计划号:" prop="orderID">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.purplanNo"></el-input>
      </el-form-item>
      <el-form-item label="供应商:" prop="supplier">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.fromOrg"></el-input>
      </el-form-item>
      <el-form-item label="物料名称:" prop="materialName">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.goodsName"></el-input>
      </el-form-item>
      <el-form-item label="计划状态:" prop="planStatus">
        <el-select v-model="searchFrom.purplanStatus" placeholder="请选择">
          <el-option
            v-for="(item,index) in planStatusOptions"
            :key="index"
            :label="item.showName"
            :value="item.itemNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交货日期:" prop="deliveryDate">
        <el-date-picker
          v-model="searchFrom.startTime"
          @change="startTimeChangeA"
          size="mini"
          style="width: 190px"
          placeholder="选择日期"
          type="date"
        ></el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom.endTime"
          @change="startTimeChangeB"
          size="mini"
          style="width: 190px"
          placeholder="选择日期"
          type="date"
        ></el-date-picker>
      </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='001P002B001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick" btnCode='001P002B002' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeBtnClick(-1)" btnCode='001P002B003' v-if="btnFlg[2]">修改</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeBtnClick(1)"  btnCode='001P002B004' v-if="btnFlg[3]">计划分配</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPlanClick"  btnCode='001P002B006' v-if="btnFlg[5]">获取港口计划</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'handleRowClick'
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column type="selection"  width="55" align="center"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="customerName"    label="操作" width="120" align="center" >
          <template slot-scope="scope"><div>
            <el-button @click="completionStatus(scope.row)" type="primary" size="small" btnCode='001P002B005' v-if="btnFlg[4]">分配情况</el-button>
          </div></template>
        </el-table-column>
        <el-table-column label="状态" align="center"  show-overflow-tooltip>
          <template slot-scope="scope"><div>
            <el-tag v-if="scope.row.purplanStatus == 2" type="danger">待分配</el-tag>
            <el-tag v-if="scope.row.purplanStatus == 6" >{{scope.row.pStatusName}}</el-tag>
            <el-tag v-if="scope.row.purplanStatus == 3|| scope.row.purplanStatus == 4 || scope.row.purplanStatus == 5" type="info">{{scope.row.pStatusName}}</el-tag>
          </div></template>
        </el-table-column>
        <el-table-column property="purorderNo" label="采购订单号"  align="center" show-overflow-tooltip width="130"></el-table-column>
        <el-table-column prop="purplanNo" label="采购日计划号" align="center" width="230" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planNo" label="港口计划号" align="center" width="120" :formatter="formatterRowEmpty" show-overflow-tooltip></el-table-column>
        <el-table-column prop="goodsName" label="物料名称"  width="150" align="center"></el-table-column>
        <el-table-column prop="goodsNo" label="物料编码" align="center" width="140"></el-table-column>
        <el-table-column prop="purplanWeight" label="采购吨数" align="center" width="120"></el-table-column>
        <el-table-column prop="toOrg"  label="收货单位" align="center" width="140"></el-table-column>
        <el-table-column prop="warehouseNameShow" label="收货仓库"  align="center" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="areaName" label="收货库位"  width="100" align="center"></el-table-column>
        <el-table-column prop="fromOrg" label="供应商" align="center" width="230" show-overflow-tooltip></el-table-column>
        <el-table-column prop="validDate" label="交货日期" align="center" width="140"></el-table-column>
        <el-table-column prop="wharfName" label="港口" align="center" width="140"></el-table-column>
        <el-table-column prop="forwarderName" label="货代" align="center" width="120"></el-table-column>
        <el-table-column prop="shipName" label="船名" align="center" width="120"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" width="120" show-overflow-tooltip :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="createUser" label="创建人" align="center" width="140"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="180"></el-table-column>
        <el-table-column prop="updateUser" label="修改人" align="center" width="140"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间" align="center" width="180"></el-table-column>

      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 修改 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="changeMark"
    @close='closeDialog'
    width="1100px"
    center>
    <div v-loading="changeLoading" >
      <span>
      <div class="bigBox">
      <div class="addressBox">
        <h5 class="title">
          <span>
            <i class="fa fa-tag iconFont" aria-hidden="true"></i>整体计划
            <hr>
          </span>
        </h5>

      </div>
      <div class="status_plan clearfix">
        <table class="status_cnt pull-left table">
          <tbody>
          <tr>
            <td>交货日期</td>
            <td>{{purchasePlan.validDate | timeFunction}}</td>
            <td>采购订单号</td>
            <td>{{purchasePlan.purorderNo}}</td>
            <td>采购日计划号</td>
            <td>{{purchasePlan.purplanNo}}</td>
          </tr>
          <tr>
            <td>收货单位</td>
            <td>{{purchasePlan.toOrg}}</td>
            <td>收货仓库</td>
            <td>{{purchasePlan.warehouseNameShow}}</td>
            <td>收料库位</td>
            <td>{{purchasePlan.areaName}}</td>
          </tr>
          <tr>
            <td>物料名称</td>
            <td>{{purchasePlan.goodsName}}</td>
            <td>物料编码</td>
            <td>{{purchasePlan.goodsNo}}</td>
            <td>采购吨数</td>
            <td>{{purchasePlan.purplanWeight}}</td>
          </tr>
          <tr>
            <td>供应商</td>
            <td>{{purchasePlan.fromOrg}}</td>
            <td>港口</td>
            <td>{{purchasePlan.wharfName}}</td>
            <td>货代</td>
            <td>{{purchasePlan.forwarderName}}</td>
          </tr>
          <tr>
            <td>船名</td>
            <td>{{purchasePlan.shipName}}</td>
            <td>创建人</td>
            <td>{{purchasePlan.createUser}}</td>
            <td>创建时间</td>
            <td>{{purchasePlan.createTime | dateFormat}}</td>
          </tr>
          <tr>
            <td>修改人</td>
            <td>{{purchasePlan.updateUser}}</td>
            <td>修改时间</td>
            <td>{{purchasePlan.updateTime | dateFormat}}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>备注</td>
            <td colspan="5" style="text-align: left;">{{purchasePlan.remark}}</td>
          </tr>
          </tbody>
        </table>
        <div class="pull-right plan_show">
          <div class="div_block">
            <span class="span_cell">计划吨数:</span><span class="black">{{purchasePlan.purplanWeight}}</span>
          </div>
          <div class="div_block">
            <span class="span_cell">已完成:</span><span class="green">{{planEsuttleWeight}}</span>
          </div>
          <div class="div_block">
            <span class="span_cell">剩余:</span><span class="red">{{(purchasePlan.purplanWeight-planEsuttleWeight).toFixed(3)}}</span>
          </div>
          <div class="div_block">
            <span class="span_cell">完成进度:</span><span class="blue">{{completePercent}}</span>
          </div>
        </div>
      </div>
      <div>
        <el-table
        :data="warehouse"
        ref="changeTableList"
        border
        bordersize="mini"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column prop="warehouseName"   label="采购计划仓库" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="weight" label="卸货吨位"  align="center" ></el-table-column>
      </el-table>
      </div>
      <div class="bottom">
        <div class="addressBox">
          <h5 class="title">
            <span>
              <i class="fa fa-tag iconFont" aria-hidden="true"></i>分配情况
              <hr>
            </span>
          </h5>
        </div>
      </div>
    <!--  表格 -->
    <el-button type="primary" @click="addChangeTab" btnCode='00DP001B001'>新增</el-button>
    <div class="table" >
      <el-table
        :data="purplanDistribution"
        ref="fenPeitableList"
        border
        bordersize="mini"
        style="width: 100%;margin-top:10px;"
        center
        :summary-method="getSummaries"
        sum-text='合计'
        show-summary
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column prop="distributionNo"   label="小计划号" align="center" width="220"  show-overflow-tooltip></el-table-column>
        <el-table-column property="distPercent" label="分配比例（%）" width="120"  align="center" >
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="4"  @input="numContro($event,scope.row)" v-model="scope.row.distPercent" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="distWeight"    label="分配吨数" align="center" width="140" >
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" :disabled=true v-model="scope.row.distWeight" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="fleet" label="车队"  width="250" align="center">
          <template slot-scope="scope"><div>
            <!-- bindCont 等于0 或者 等于空 能修改     不等于空或者大于0 不能修改-->
            <el-select v-model="purplanDistribution[scope.$index].fleet" v-if="purplanDistribution[scope.$index].bindCont == '0' || purplanDistribution[scope.$index].bindCont == ''" placeholder="请选择" size="mini" style="width:220px;">
              <el-option
                v-for="(item,index) in fleetList"
                :key="index"
                :label="item.fleetName"
                :value="item.fleet">
              </el-option>
            </el-select>
            <el-select v-model="purplanDistribution[scope.$index].fleet" v-else :disabled=true placeholder="请选择" size="mini" style="width:220px;">
              <el-option
                v-for="(item,index) in fleetList"
                :key="index"
                :label="item.fleetName"
                :value="item.fleet">
              </el-option>
            </el-select>
          </div></template>
        </el-table-column>
        <el-table-column prop="warehouse"    label="收货仓库1" align="center" width="140">
          <template slot-scope="scope"><div>
            <el-select v-model="scope.row.warehouse" placeholder="请选择" size="mini">
              <el-option
                v-for="(item,index) in warehouse"
                :key="index"
                :label="item.warehouseName"
                :value="item.warehouse">
              </el-option>
            </el-select>
          </div></template>
        </el-table-column>
        <el-table-column prop="wharfxId"    label="码头"  width="120" align="center" >
          <template slot-scope="scope"><div>
            <el-select v-model="scope.row.wharfxId" placeholder="请选择" size="mini">
              <el-option
                v-for="(item,index) in wharfList"
                :key="index"
                :label="item.showName"
                :value="item.itemNo">
              </el-option>
            </el-select>
          </div></template>
        </el-table-column>
        <el-table-column prop="areaName" label="场区" align="center" width="140">
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" v-model="scope.row.areaName" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="stackPosition"    label="垛位" align="center" width="140">
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" v-model="scope.row.stackPosition" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="carnumLimit"  label="车数1" align="center" width="140">
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" v-number-input.float="3" v-model="scope.row.carnumLimit" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="locationName" label="库位1"  align="center" width="120">
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" v-model="scope.row.locationName" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="remark"  label="备注" align="center" width="140">
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" v-model="scope.row.remark" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="" label="操作" width="120" align="center" >
          <template slot-scope="scope"><div>
            <el-button  v-if="scope.row.distributionStatus == 1" @click="lockDistributionPlan(scope.row)"  type="text" size="small" btnCode='00DP001B007'  icon = 'el-icon-lock' >锁定</el-button>
            <el-button  v-if="scope.row.distributionStatus == 2" @click="unLockDistributionPlan(scope.row)" type="text" size="small" btnCode='00DP001B007' icon = 'el-icon-unlock'>解锁</el-button>
            <el-button v-if="scope.row.id==null||scope.row.id==''||scope.row.id==undefined" @click.native.prevent="delData(scope.$index, fenPeitableList)" type="text" size="small" icon="el-icon-delete" btnCode='00DP001B007' >删除</el-button>
          </div></template>
        </el-table-column>
      </el-table>
    </div>
  </div>
      </span>
      <div style="width:150px;margin:20px auto;">
         <el-button type="primary" @click="save()" size='mini' >保存</el-button>
        <el-button @click="closeDialog" size='mini' >取消</el-button>
      </div>
    </div>
    </el-dialog>
     <!-- 计划分配 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="distributionMark"
    @close='closeDialog'
    width="1100px"
    center>
    <div v-loading="changeLoading">
      <span>
      <div class="bigBox">
      <div class="addressBox">
        <h5 class="title">
          <span>
            <i class="fa fa-tag iconFont" aria-hidden="true"></i>整体计划
            <hr>
          </span>
        </h5>
      </div>
      <div class="status_plan clearfix">
        <table class="status_cnt2 pull-left table">
          <tbody>
          <tr>
            <td>交货日期</td>
            <td>{{purchasePlan.validDate | timeFunction}}</td>
            <td>采购订单号</td>
            <td>{{purchasePlan.purorderNo}}</td>
            <td>采购日计划号</td>
            <td>{{purchasePlan.purplanNo}}</td>
          </tr>
          <tr>
            <td>收货单位</td>
            <td>{{purchasePlan.toOrg}}</td>
            <td>收货仓库</td>
            <td>{{purchasePlan.warehouseNameShow}}</td>
            <td>收料库位</td>
            <td>{{purchasePlan.areaName}}</td>
          </tr>
          <tr>
            <td>物料名称</td>
            <td>{{purchasePlan.goodsName}}</td>
            <td>物料编码</td>
            <td>{{purchasePlan.goodsNo}}</td>
            <td>采购吨数</td>
            <td>{{purchasePlan.purplanWeight}}</td>
          </tr>
          <tr>
            <td>供应商</td>
            <td>{{purchasePlan.fromOrg}}</td>
            <td>港口</td>
            <td>{{purchasePlan.wharfName}}</td>
            <td>货代</td>
            <td>{{purchasePlan.forwarderName}}</td>
          </tr>
          <tr>
            <td>船名</td>
            <td>{{purchasePlan.shipName}}</td>
            <td>创建人</td>
            <td>{{purchasePlan.createUser}}</td>
            <td>创建时间</td>
            <td>{{purchasePlan.createTime | dateFormat}}</td>
          </tr>
          <tr>
            <td>修改人</td>
            <td>{{purchasePlan.updateUser}}</td>
            <td>修改时间</td>
            <td>{{purchasePlan.updateTime | dateFormat}}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>备注</td>
            <td colspan="5" style="text-align: left;">{{purchasePlan.remark}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div>
        <el-table
        :data="warehouse"
        ref="warehouseDistributionList"
        border
        bordersize="mini"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column prop="warehouseName"   label="采购计划仓库" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="weight" label="卸货吨位"  align="center" ></el-table-column>
      </el-table>
      </div>
      <div class="bottom">
        <div class="addressBox">
          <h5 class="title">
            <span>
              <i class="fa fa-tag iconFont" aria-hidden="true"></i>分配情况
              <hr>
            </span>
          </h5>
        </div>
      </div>
    <!--  表格 -->
    <el-button type="primary" @click="addChangeTab" btnCode='00DP001B001'>新增</el-button>
    <div class="table" >
      <el-table
        :data="purplanDistribution"
        ref="distributionData"
        border
        bordersize="mini"
        style="width: 100%;margin-top:10px;"
        center
        :summary-method="getSummaries"
        show-summary
        sum-text='合计'
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column prop="distributionNo"   label="小计划号" align="center" width="230" show-overflow-tooltip></el-table-column>
        <el-table-column property="distPercent" label="分配比例（%）" width="120"  align="center" >
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="4" @input="numContro($event,scope.row)" v-model="scope.row.distPercent" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="distWeight"     label="分配吨数" align="center" width="140" >
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" :disabled=true v-model="scope.row.distWeight" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="fleet"    label="车队"  width="250" align="center">
          <template slot-scope="scope"><div>
            <el-select v-model="scope.row.fleet" placeholder="请选择" size="mini" style="width:220px;">
              <el-option
                v-for="(item,index) in fleetList"
                :key="index"
                :label="item.fleetName"
                :value="item.fleet">
              </el-option>
            </el-select>
          </div></template>
        </el-table-column>
        <el-table-column prop="warehouse"    label="收货仓库1" align="center" width="140">
          <template slot-scope="scope"><div>
            <el-select v-model="scope.row.warehouse" placeholder="请选择" size="mini">
              <el-option
                v-for="(item,index) in warehouse"
                :key="index"
                :label="item.warehouseName"
                :value="item.warehouse">
              </el-option>
            </el-select>
          </div></template>
        </el-table-column>
        <el-table-column prop="wharfxId"    label="码头"  width="120" align="center" >
          <template slot-scope="scope"><div>
            <el-select v-model="scope.row.wharfxId" placeholder="请选择" size="mini">
              <el-option
                v-for="(item,index) in wharfList"
                :key="index"
                :label="item.showName"
                :value="item.itemNo">
              </el-option>
            </el-select>
          </div></template>
        </el-table-column>
        <el-table-column prop="areaName" label="场区" align="center" width="140">
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" v-model="scope.row.areaName" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="stackPosition"    label="垛位" align="center" width="140">
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" v-model="scope.row.stackPosition" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="carnumLimit"  label="车数1" align="center" width="140">
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" v-number-input.float="3" v-model="scope.row.carnumLimit" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="locationName" label="库位1"  align="center" width="120">
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" v-model="scope.row.locationName" size="mini" ></el-input>
          </div></template>
        </el-table-column>

        <el-table-column prop="remark"  label="备注" align="center" width="140">
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="100" v-model="scope.row.remark" size="mini" ></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="" label="操作" width="120" align="center" >
          <template slot-scope="scope"><div>
            <span v-if="scope.$index == 0">-</span>
            <el-button v-else-if="scope.row.id==null||scope.row.id==''||scope.row.id==undefined" @click.native.prevent="delData(scope.$index, fenPeitableList)" type="text" size="small" icon="el-icon-delete" btnCode='' >删除</el-button>
          </div></template>
        </el-table-column>
      </el-table>
    </div>
  </div>
      </span>
      <div style="width:150px;margin:15px auto;">
         <el-button type="primary" @click="save()" size='mini'>保存</el-button>
        <el-button @click="closeDialog" size='mini'>取消</el-button>
      </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDisPurchasePlanList, // 计划分配页面的查询计划列表
  getDisPlanStatusList, // 计划分配页码获取计划状态列表
  distributionInfoEdit, // 查询修改计划分配信息
  distributionLock, // 锁定和解锁计划
  saveDistributionEdit, // 保存修改或分配的计划
  getTempEvacuatePlan // 获取港口计划
} from '@/api/zhb-sgHarbour'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      emptyFn: emptyFn,
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P002B001', '001P002B002', '001P002B003',
        '001P002B004', '001P002B005', '001P002B006'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        collectPlanTime: '',
        purorderNo: '',
        purplanNo: '',
        fromOrg: '',
        planStatus: '',
        goodsName: '',
        purplanStatus: '',
        startTime: '',
        endTime: ''
      },
      planStatusOptions: [],
      value: '',
      tableList: [],
      tabLoading: false,
      fenPeitableList: [],
      // 新增
      addShengChengLoading: false,
      addFaBuLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      faBuId: '',
      planStatus: '',
      changeMark: false,
      changeTableList: [],
      purchasePlan: '', // 计划信息
      planEsuttleWeight: '', // 已完成计划吨数
      purplanDistribution: [], // 计划分配信息
      warehouse: [], // 仓库信息
      wharfList: [], // 码头信息
      fleetList: [],
      completePercent: '', // 完成率
      // 计划分配
      distributionMark: false,
      warehouseDistributionList: [],
      distributionData: [],
      distributionNoPrefix: '', // 小计划号的前缀
      distributionNoSuffix: '', // 小计划号的后缀
      changeLoading: false,
      ifShowFleet: false
    }
  },
  created () {
    this.getToDay()
    this.btnFlg = getBtn(this.btnIdArr, '/sgPlanManagement/planDistribution')
    this.getSeatchData()
    this.initDisPlanStatus()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  filters: {
    timeFunction: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }

      return year + '-' + month + '-' + date
    }
  },
  methods: {
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }

      return year + '-' + month + '-' + date
    },
    /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 年月日
    timeStamp2 (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log("time:" + JSON.stringify(now));
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    // 时间改变
    startTimeChangeA () {
      this.searchFrom.startTime = this.timeStamp2(this.searchFrom.startTime)
    },
    // 时间改变
    startTimeChangeB () {
      this.searchFrom.endTime = this.timeStamp2(this.searchFrom.endTime)
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime())) // 当天的早8点时间戳
      this.searchFrom.startTime = this.timeStamp2(new Date(dateStartStr).getTime())
      this.searchFrom.endTime = this.timeStamp2(new Date(dateStartStr).getTime() + 86400000)
    },
    // 初始化计划状态
    initDisPlanStatus () {
      getDisPlanStatusList().then(res => {
        this.planStatusOptions = res
        this.planStatusOptions.unshift({ 'itemNo': '', 'showName': '全部' })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getDisPurchasePlanList(this.searchFrom).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.tabLoading = false
        // console.log(err.message)
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        startTime: '',
        endTime: ''
      }
      this.getToDay()
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      this.$refs.tableRef.toggleRowSelection(row)
      this.changeFlag = row.newFlg
      this.changeData = row
      this.faBuId = row.id
      this.planStatus = row.planStatus
    },
    // 点击修改按钮
    changeBtnClick (param) {
      let selectData = this.$refs.tableRef.selection
      let purchasePlanIds = {
        purchasePlanId: '',
        flag: ''
      }
      if (selectData.length < 1) {
        this.$message.error('请选择一条数据进行操作')
      } else if (selectData.length > '1') {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        if (Number(param) < 0) {
          purchasePlanIds.flag = 6
          if (selectData[0].purplanStatus != 6) {
            this.$message.error('只能修改已分配的计划')
            return
          }
        }
        if (Number(param) > 0) {
          purchasePlanIds.flag = 2
          if (selectData[0].purplanStatus != 2) {
            this.$message.error('只分配待分配的计划')
            return
          }
        }
        if (Number(param) < 0) {
          this.title = '计划修改'
          this.changeMark = true
        } else if (Number(param) > 0) {
          this.distributionMark = true
          this.title = '计划分配'
        }
        purchasePlanIds.purchasePlanId = selectData[0].purchasePlanId
        // console.log(purchasePlanIds)
        // purchasePlanId.push(selectData[0].purchasePlanId)
        this.changeLoading = true
        distributionInfoEdit(purchasePlanIds).then(res => {
          this.changeLoading = false
          this.purchasePlan = res.tPurchasePlan
          this.planEsuttleWeight = Number(res.planEsuttleWeight).toFixed(3)
          this.purplanDistribution = res.purplanDistribution
          this.warehouse = res.warehouse
          this.wharfList = res.wharfList
          this.fleetList = res.fleetList
          this.fleetList.unshift({ fleetName: '请选择', fleet: '' })
          this.completePercent = res.completePercent
          this.distributionNoSuffix = res.distributionNoSuffix
          this.distributionNoPrefix = res.distributionNoPrefix

          let no = this.distributionNoPrefix + '_' + this.distributionNoSuffix
          if (this.purplanDistribution.length == 0) {
            var list = {
              distributionNo: no,
              id: null,
              distPercent: '',
              distWeight: '',
              fleetName: '',
              fleet: this.fleetList[0].fleet,
              warehouse: this.warehouse[0].warehouse,
              warehouseName: '',
              carnumLimit: '999',
              locationName: '',
              wharfxName: '',
              wharfxId: this.wharfList[0].itemNo,
              areaName: '',
              stackPosition: '',
              remark: '',
              vehicleTypes: '',
              vehicleTypesName: '',
              purplanId: this.purchasePlan.id
            }
            this.distributionNoSuffix++
            this.purplanDistribution.push(list)
          }
        }).catch(err => {
          this.changeLoading = false
          this.$message.error(err.message)
        })
      }
    },
    closeDialog () {
      this.changeMark = false
      this.distributionMark = false
      this.title = ''
      this.showDataInit()
    },
    //
    showDataInit () {
      this.purchasePlan = ''
      this.planEsuttleWeight = ''
      this.purplanDistribution = []
      this.warehouse = []
      this.wharfList = []
      this.fleetList = []
      this.completePercent = ''
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 验证重复元素，有重复返回true；否则返回false
    isRepeat (arr) {
      var hash = {}
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true
      }
      return false
    },
    save () {
      // console.log(this.purplanDistribution)
      let fleetArr = []
      for (let index = 0; index < this.purplanDistribution.length; index++) {
        fleetArr.push(this.purplanDistribution[index].fleet)
      }
      if (this.isRepeat(fleetArr) == true) {
        this.$message.error('所选车队不能重复！')
      } else {
        this.changeLoading = true
        saveDistributionEdit(this.purplanDistribution).then(res => {
          this.changeLoading = false
          this.$message.success(res)
          this.closeDialog()
          this.getSeatchData(this.searchFrom)
        }).catch(err => {
          this.changeLoading = false
          this.$message.error(err.message)
        })
      }
    },
    // 点击计划分配
    distributionClick () {
      let selectData = this.$refs.tableRef.selection
      if (selectData.length < 1) {
        this.$message.error('请选择一条数据进行操作')
      } else if (selectData.length > 1) {
        this.$message.error('只能选择一条数据进行操作')
      } else {
        if (selectData[0].purplanStatus == '2') {
          this.distributionMark = true
          this.title = '计划分配'
        } else {
          this.$message.error('只能选择待分配的数据进行分配！')
        }
      }
    },
    // 合同列表取消
    heTongQuXiaoClick () {
      this.heTongMark = false
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.heTongFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.heTongFrom.pageNo = val
      // this.getSearchData()
    },
    // 点击完成情况
    completionStatus (row) {
      localStorage.setItem('purchasePlan', JSON.stringify(row))
      this.$router.push('/sgPlanManagement/completionStatus')
      // this.$router.push({
      //   name: 'completionStatus',
      //   params: {
      //     purchasePlan: row
      //   }
      // })
    },
    // 点击修改添加表格行
    addChangeTab () {
      let no = this.distributionNoPrefix + '_' + this.distributionNoSuffix
      var list = {
        bindCont: '',
        distributionNo: no,
        id: null,
        distPercent: '',
        distWeight: '',
        fleetName: '',
        fleet: this.fleetList[0].fleet,
        warehouse: this.warehouse[0].warehouse,
        warehouseName: '',
        carnumLimit: '999',
        locationName: '',
        wharfxName: '',
        // wharfxId:this.wharfList[0].itemNo,
        wharfxId: this.purplanDistribution[0].wharfxId,
        areaName: '',
        stackPosition: '',
        remark: '',
        vehicleTypes: '',
        vehicleTypesName: '',
        purplanId: this.purchasePlan.id
      }
      this.distributionNoSuffix++
      this.purplanDistribution.push(list)
    },
    // 删除表格行
    delData (index, rows) {
      this.purplanDistribution.splice(index, 1)
    },
    // 锁定分配的计划
    lockDistributionPlan (row) {
      this.lockBtn = true
      let param = {}
      param.id = row.id
      param.distributionStatus = 2
      distributionLock(param).then(res => {
        row.distributionStatus = res
        this.lockBtn = false
        this.$message.success('锁定成功')
      }).catch(err => {
        this.$message.error(err.message)
        this.lockBtn = false
      })
    },
    // 解锁分配的计划
    unLockDistributionPlan (row) {
      this.unLockBtn = true
      let param = {}
      param.id = row.id
      param.distributionStatus = 1
      distributionLock(param).then(res => {
        row.distributionStatus = res
        this.unLockBtn = false
        this.$message.success('解锁成功')
      }).catch(err => {
        this.$message.error(err.message)
        this.unLockBtn = false
      })
    },
    // getSummaries(param) {
    //   const { columns, data } = param
    //   const sums = []
    //   columns.forEach((column,index) => {
    //     if (index === 0) {
    //       sums[index] = '合计'
    //       return
    //     }
    //     const values = data.map(item=>Number(item[column.property]))
    //     if (index === 2) {
    //       const flag = values.every(item=>isNaN(item))
    //       if(flag){
    //         return sums[index] = "N/A"
    //       }else{
    //         sums[index] = values.reduce((total,item)=>total+item);
    //         sums[index] = Math.round(sums[index]*1000)/1000;
    //         sums[index] += " 吨"
    //       }
    //     }
    //   })
    //   return sums;
    // },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          if (column.label == '分配吨数') {
            sums[index] = sums[index].toFixed(2) + ' 吨'
            // console.log(sums[index], '11111111')
          } else {
            sums[index] = ''
          }
        } else {
          sums[index] = ''
        }
      })

      return sums
    },
    cancel (p) {
      if (p) {
        this.changeMark = false
      } else {

      }
    },
    numContro (value, row) {
      let val = (value && value.split('')) || []
      // caseData.claimMessageVo是值所在的对象
      row.distPercent = val.join('').match(/^\d*(\.?\d{0,1})/g)[0] || null
      if (row.distPercent) {
        row.distWeight = (this.purchasePlan.purplanWeight / 100 * row.distPercent).toFixed(2)
      } else {
        row.distWeight = ''
      }
    },
    // 获取港口计划按钮
    getPlanClick () {
      getTempEvacuatePlan().then(res => {
        this.$message.success('成功')
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 25px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}

//  /deep/ .inpBox .el-range-editor--mini .el-input__inner {
//    width: 150px;
// }
// .inpBox .el-date-editor{
//     width: 280px!important;
//  }
.searchBtnBox{
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
.bigBox{
  overflow-x: hidden;
}
.status_plan{
  margin-top: -10px;
  // margin-left: 10px;
  width: 100%;
  // margin-top: 10px;
  height: 266px;
  overflow: hidden;
}
.status_plan .status_cnt {
    margin-bottom: 16px;
}
.status_plan .status_cnt2 {
    margin-bottom: 16px;
}
.status_cnt {
    width: 76%;
    // margin-top: 10px;
    height: 266px;
}
.status_cnt2 {
    width: 100%;
    // margin-top: 10px;
    height: 266px;
}
.pull-left {
    float: left!important;
}
table {
    font-size: 14px;
    border-spacing: 0;
    border-collapse: collapse;
    background-color: transparent;
}
.status_plan table tr td:nth-child(odd) {
    background: #2980B9;
    color: #fff;
    width: 11%;
}
.status_plan table tr td + td {
    border-left: 2px solid #fff;
}
.status_plan table tr td {
    padding: 2px;
    cursor: default;
    border-bottom: 1px solid #fff;
}
.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
    // padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
}
.table tr th, .table tr td {
    text-align: center;
    vertical-align: middle!important;
    word-wrap: break-word;
}
.table td, .table th {
    vertical-align: middle;
}
td {
    display: table-cell;
    // vertical-align: inherit;
}
.status_plan table tr td:nth-child(even) {
    word-break: break-word;
    background: rgba(158, 158, 158, 0.39);
    width: 21%;
}
.plan_show {
    box-sizing: border-box;
    width: 22%;
    background: #eef3fa;
    text-align: left;
    font-size: 16px;
    padding: 20px 10px;
    height: 105%;
    // height: 275px;
}
.pull-right {
    float: right!important;
    // margin-right: 15px;
}
.plan_show .div_block {
    line-height: 50px;
}
.plan_show .span_cell {
    min-width: 75px;
    display: inline-block;
    text-align: right;
    // margin-right: 10px;
}
.plan_show .div_block span:nth-of-type(2) {
    float: right;
    margin-right: 10px;
}
.green {
  color: green;
}
.blue {
  color: blue;
}
.red {
  color: red;
}
.black {
  color: #000;
}
.black, .blue, .red, .green {
  font-weight: bold;
  font-size: 18px;
}
.bottom{
  margin-top: 15px;
}
/deep/.el-dialog__body {
    padding: 30px 20px;
    color: #606266;
    font-size: 14px;
    background: #EAEAEF;
}
</style>
